import React from "react";
import {Skeleton} from "@material-ui/lab";


export function TextAreaSkeleton(){
    return(
        <Skeleton style={{width: "100%", height: 40}} animation="wave" />
    )
}